var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMailicon = function SvgMailicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.01562H4V4H16V6.01562ZM16 9.01562H4V7H16V9.01562ZM16 12.0156H4V10H16V12.0156ZM19.9844 1.98438C19.9844 1.45313 19.7812 1 19.375 0.625C19 0.21875 18.5469 0.015625 18.0156 0.015625H1.98438C1.45312 0.015625 0.984375 0.21875 0.578125 0.625C0.203125 1 0.015625 1.45313 0.015625 1.98438V13.9844C0.015625 14.5469 0.203125 15.0312 0.578125 15.4375C0.984375 15.8125 1.45312 16 1.98438 16H16L19.9844 19.9844V1.98438Z",
    fill: "#8DA3C5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mailicon.d3deba33.svg";
export { ForwardRef as ReactComponent };